import styled from 'styled-components';

import { theme } from '../theme';

import * as Base from './base';

const StyledInput = styled(Base.StyledInput)`
  background-color: ${theme.backgroundColor};
  &:focus {
    border: 1px solid ${Styles.color.accent};
  }
`;

export * from './base';
export { StyledInput };
